export default __webpack_public_path__ + "static/media/feature-item-club.0aaf8731.svg";